import { TCreateAlarmSituationDTO } from './alarmSituations.types.ts'

const generateCreateParameterDTO = (): TCreateAlarmSituationDTO => ({
  name: '',
  level: 'WARNING',
  comment: '',
  forAllEquipment: true,
  equipmentModels: [],
  formula: [],
})

const alarmSituationGenerators = { generateCreateParameterDTO }
export default alarmSituationGenerators
